import { createSlice } from "@reduxjs/toolkit";

interface FormFilterInterface {
  searchText: string;
  deptCodeLv1: string;
  deptCodeLv2: string;
  leaveReasonCode: string;
  positionCode: string;
  month: number;
  workingAreaCode: string;
  year: number;
}

interface InitialState {
  filterInput: FormFilterInterface;
}

const initialState: InitialState = {
  filterInput: {
    searchText: "",
    deptCodeLv1: "",
    deptCodeLv2: "",
    leaveReasonCode: "",
    positionCode: "",
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
    workingAreaCode: "",
  },
};

const formFilterTimeKeepingHRSlice = createSlice({
  name: "formFilterTimeKeepingHR",
  initialState,
  reducers: {
    formFilterTimeKeepingHRUpdate: (state, action) => {
      Object.assign(state.filterInput, action.payload);
    },

    formFilterTimeKeepingHRReset: () => {
      return { ...initialState };
    },
  },
});

export const { formFilterTimeKeepingHRUpdate, formFilterTimeKeepingHRReset } =
  formFilterTimeKeepingHRSlice.actions;

export default formFilterTimeKeepingHRSlice.reducer;
